<app-dialog-header [title]="'GENERAL.PROPERTY.FILTER_BY'" (onClick)="cancel()"></app-dialog-header>

<div
    mat-dialog-content
    class="filter-by-dialog-content px-24 pt-24 pb-8"
    [class.overflow-y-visible-override]="selectedUserAttributeFilter?.type === ExtendedAttributeType.Date || isSelectedDateRangeFilter"
>
    <div class="filter-by-dialog-body">
        <ng-container *ngIf="!isLoading; else shimmer">
            <ng-container *ngIf="filters.length; else noFilters">
                <div class="filter-by-dialog-split">
                    <div class="filter-by-dialog-categories">
                        <button
                            type="button"
                            class="filter-by-dialog-category"
                            *ngFor="let item of filters; trackBy: trackFilterCategory"
                            [class.filter-by-dialog-category-selected]="selectedFilter.value?.name === item.name"
                            (click)="selectFilterCategory(item)"
                        >
                            <span class="filter-by-dialog-category-label">{{ item.translationKey | translate }}</span>
                            <span *ngIf="filterCategoryCounts[item.name]" class="filter-by-dialog-category-count">{{ filterCategoryCounts[item.name] }}</span>
                        </button>
                    </div>

                    <div class="filter-by-dialog-options">
                        <ng-container *ngIf="!selectedFilter.value?.isUserAttribute; else userAttribute">
                            <div class="filter-by-dialog-filter-surface p-24" [ngSwitch]="selectedFilter.value?.name">
                                <app-filter-by-module
                                    #moduleList
                                    *ngSwitchCase="'module'"
                                    [preSelectUnassigned]="isUnassignedModuleSelected"
                                    (choosenModules)="loadModuleList($event)"
                                    (addedToList)="addToList($event)"
                                ></app-filter-by-module>
                                <app-experience-filter
                                    #experienceList
                                    *ngSwitchCase="'experience'"
                                    [preSelectUnassigned]="isUnassignedExperienceSelected"
                                    (choosenExperiences)="loadExperienceList($event)"
                                    (addedToList)="addToList($event)"
                                ></app-experience-filter>
                                <app-audience-filter
                                    #audienceList
                                    *ngSwitchCase="'audience'"
                                    [preSelectUnassigned]="isUnassignedAudienceSelected"
                                    (choosenAudiences)="loadAudienceList($event)"
                                    (addedToList)="addToList($event)"
                                    [isSingleSelect]="false"
                                    [showNotAssiggnedUsersControl]="true"
                                ></app-audience-filter>
                                <app-team-filter
                                    #teamList
                                    *ngSwitchCase="'team'"
                                    [preSelectUnassigned]="isUnassignedTeamSelected"
                                    (choosenTeams)="loadTeamList($event)"
                                    (addedToList)="addToList($event)"
                                ></app-team-filter>
                                <app-role-filter #roleList *ngSwitchCase="'userRole'" (choosenRoles)="loadUserRoleList($event)" (addedToList)="addToList($event)"> </app-role-filter>
                                <app-status-filter #statusList *ngSwitchCase="'status'" (addedToList)="addToList($event)"></app-status-filter>
                                <app-request-date-filter
                                    *ngSwitchCase="'CreatedOn'"
                                    [selectedFilter]="selectedFilter.value"
                                    (addedToList)="addToList($event)"
                                ></app-request-date-filter>
                                <app-request-date-filter
                                    *ngSwitchCase="'LastModified'"
                                    [selectedFilter]="selectedFilter.value"
                                    (addedToList)="addToList($event)"
                                ></app-request-date-filter>
                            </div>
                        </ng-container>
                        <ng-template #userAttribute>
                            <div class="filter-by-dialog-filter-surface p-24">
                                <app-text-filter
                                    *ngIf="selectedBuiltInUserTextField"
                                    [builtInUserTextField]="selectedBuiltInUserTextField"
                                    (addedToList)="addToList($event)"
                                ></app-text-filter>
                                <app-attribute-with-options-filter
                                    #attributeOptionsList
                                    [userAttribute]="selectedUserAttributeFilter"
                                    (addedToList)="addToList($event)"
                                    *ngIf="selectedUserAttributeFilter?.optionsEnabled && selectedUserAttributeFilter?.type !== ExtendedAttributeType.Address"
                                ></app-attribute-with-options-filter>
                                <app-address-filter
                                    [userAttribute]="selectedUserAttributeFilter"
                                    [userAttributeFilter]="selectedUserAttributeFilterValue"
                                    (addedToList)="addToList($event)"
                                    *ngIf="selectedUserAttributeFilter?.type === ExtendedAttributeType.Address"
                                ></app-address-filter>
                                <app-date-filter
                                    #dateFilter
                                    [userAttribute]="selectedUserAttributeFilter"
                                    [userAttributeFilter]="selectedUserAttributeFilterValue"
                                    (addedToList)="addToList($event)"
                                    *ngIf="selectedUserAttributeFilter?.type === ExtendedAttributeType.Date"
                                ></app-date-filter>
                                <app-range-filter
                                    #numberFilter
                                    [userAttribute]="selectedUserAttributeFilter"
                                    [userAttributeFilter]="selectedUserAttributeFilterValue"
                                    (addedToList)="addToList($event)"
                                    *ngIf="selectedUserAttributeFilter?.type === ExtendedAttributeType.Number && !selectedUserAttributeFilter.optionsEnabled"
                                >
                                </app-range-filter>
                                <app-text-filter
                                    #textFilter
                                    [userAttribute]="selectedUserAttributeFilter"
                                    (addedToList)="addToList($event)"
                                    *ngIf="!selectedBuiltInUserTextField && selectedUserAttributeFilter?.type === ExtendedAttributeType.Text && !selectedUserAttributeFilter.optionsEnabled"
                                ></app-text-filter>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </ng-container>

            <ng-template #noFilters>
                <div class="no-options-container" fxLayout="column">
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <mat-icon svgIcon="empty"></mat-icon>
                        <p class="mt-12 mb-24">{{ 'GENERAL.MESSAGE.NO_FILTERS_AVAILABLE' | translate }}</p>
                    </div>
                </div>
            </ng-template>
        </ng-container>

        <ng-template #shimmer>
            <div class="filter-by-dialog-split filter-by-dialog-layout-shimmer">
                <div class="filter-by-dialog-categories">
                    <div class="filter-shimmer-category animate" *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8]"></div>
                </div>

                <div class="filter-by-dialog-options p-24">
                    <div class="filter-shimmer-title animate mb-16"></div>
                    <div class="filter-shimmer-controls mb-16" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="filter-shimmer-control animate"></div>
                        <div class="filter-shimmer-control animate"></div>
                    </div>
                    <div class="filter-shimmer-table">
                        <div class="filter-shimmer-row" *ngFor="let item of [1, 2, 3, 4, 5, 6]" fxLayout="row" fxLayoutAlign="start center">
                            <div class="filter-shimmer-avatar animate mr-12"></div>
                            <div class="filter-shimmer-line animate flex-1"></div>
                            <div class="filter-shimmer-button animate ml-16"></div>
                        </div>
                    </div>
                    <div class="filter-shimmer-checkbox animate mt-16"></div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
<div mat-dialog-actions class="filter-by-dialog-actions" *ngIf="filters.length">
    <div *ngIf="selectedFiltersGroups.length" class="filter-by-dialog-active-filters bg-gray-100 rounded px-16 py-12">
        <div class="flex flex-col gap-2">
            <div
                *ngFor="let group of selectedFiltersGroups; trackBy: trackSelectedFilterGroup"
                class="flex flex-row flex-wrap items-center gap-2"
            >
                <span class="shrink-0 whitespace-nowrap text-xs font-semibold leading-5 text-darktextcolor">
                    {{ group.categoryLabel }} ({{ group.chips.length }}):
                </span>
                <span
                    *ngFor="let chip of group.chips; trackBy: trackSelectedFilterChip"
                    class="filter-active-chip box-border inline-flex h-6 max-w-full shrink-0 items-center rounded-full py-0 pl-3 pr-1 text-xs leading-none text-white"
                    [style.background-color]="group.color"
                >
                    <span class="max-w-[240px] overflow-hidden text-ellipsis whitespace-nowrap">{{ chip.chipLabel }}</span>
                    <button
                        *ngIf="removable"
                        type="button"
                        class="filter-chip-remove"
                        [attr.aria-label]="'GENERAL.BUTTON.REMOVE' | translate"
                        (click)="removeFilterChip(chip)"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </span>
            </div>
        </div>
    </div>

    <div class="filter-by-dialog-action-buttons">
        <app-white-button [label]="'GENERAL.LABEL.CLEAR_ALL'" [disabled]="!list.length" (onClick)="clearFilters()"></app-white-button>

        <div class="flex items-center">
            <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="cancel()"></app-white-button>
            <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="save()"></app-flat-button>
        </div>
    </div>
</div>
